import VueScrollTo from 'vue-scrollto';
import Vue from 'vue';
import Slide from './components/Menu.vue';

import labels from './labels';
import router from './router';
import store from './store';
import './registerServiceWorker';

import App from './App.vue';
import Header from './components/Header.vue';
import Banner from './components/Banner.vue';
import Service from './components/Service.vue';
import Person from './components/Person.vue';
import Project from './components/Project.vue';
import Testimonial from './components/Testimonial.vue';
import Testimonials from './components/Testimonials.vue';
import Contact from './components/Contact.vue';
import Footer from './components/Footer.vue';

import Twitter from './components/SVG/twitter_icon.vue';
import LinkedIn from './components/SVG/linkedin_icon.vue';
import LinkedIn2 from './components/SVG/linkedin_icon_2.vue';
import Phone from './components/SVG/phone-icon.vue';
import Github from './components/SVG/github-icon.vue';
import Email from './components/SVG/email-icon.vue';

Vue.component('hf-header', Header);
Vue.component('hf-menu', Slide);
Vue.component('hf-banner', Banner);
Vue.component('hf-service', Service);
Vue.component('hf-person', Person);
Vue.component('hf-project', Project);
Vue.component('hf-testimonial', Testimonial);
Vue.component('hf-testimonials', Testimonials);
Vue.component('hf-contact', Contact);
Vue.component('hf-footer', Footer);

// SVGs
Vue.component('twitter-icon', Twitter);
Vue.component('linkedin-icon', LinkedIn);
Vue.component('linkedin-icon-2', LinkedIn2);
Vue.component('phone-icon', Phone);
Vue.component('github-icon', Github);
Vue.component('email-icon', Email);

Vue.use(VueScrollTo);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n: labels,
  render: h => h(App),
}).$mount('#app');
